import axios from 'axios';
const url = 'https://api-passport.advanceagro.net';
// ฟังก์ชันสำหรับส่งข้อมูลฟอร์ม
export const submitFormData = async (formData: any) => {
  try {
    const token = localStorage.getItem('gatekeeper_token');
    const res = await axios.post(`${url}/fpapi/shop`, formData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
    });
    return res.data; // ส่งคืนข้อมูลเมื่อสำเร็จ
  } catch (err) {
    console.error('Error submitting data:', err);
    throw err; // ส่งข้อผิดพลาดกลับ
  }
};

// ฟังก์ชันสำหรับส่งข้อมูลฟอร์ม
export const submitFormReNewShopData = async (formData: any) => {
  try {
    const token = localStorage.getItem('gatekeeper_token');
    const res = await axios.post(`${url}/fpapi/renew`, formData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
    });
    return res.data; // ส่งคืนข้อมูลเมื่อสำเร็จ
  } catch (err) {
    console.error('Error submitting data:', err);
    throw err; // ส่งข้อผิดพลาดกลับ
  }
};

// ฟังก์ชันสำหรับดึงข้อมูล Dropdown
export const fetchDropdownData = async () => {
  try {
    const res = await axios.get('https://api-passport.advanceagro.net/fpapi/dropdown');
    return res.data; // ส่งคืนข้อมูล Dropdown
  } catch (err) {
    console.error('Error fetching dropdown data:', err);
    throw err; // ส่งข้อผิดพลาดกลับ
  }

};

export const fatchZoomData = async (shopId) => {
  try {
    const token = localStorage.getItem('gatekeeper_token'); // เพิ่ม token ถ้าจำเป็น
    const res = await axios.get(`https://api-passport.advanceagro.net/fpapi/zoom/${shopId}`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    } );
    return res.data; // ส่งคืนข้อมูล Dropdown
  } catch (err) {
    console.error('Error fetching dropdown data:', err);
    throw err; // ส่งข้อผิดพลาดกลับ
  }
};

export const fetchZoomVideos = async (shopId) => {
  try {
    const token = localStorage.getItem('gatekeeper_token'); // เพิ่ม token ถ้าจำเป็น
    const res = await axios.get(`https://api-passport.advanceagro.net/fpapi/zoom_vdo/${shopId}`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    } );
    return res.data; // ส่งคืนข้อมูล Dropdown
  } catch (err) {
    console.error('Error fetching dropdown data:', err);
    throw err; // ส่งข้อผิดพลาดกลับ
  }
};

// ฟังก์ชันสำหรับดึงข้อมูล shop
export const fetchShopData = async () => {
  try {
    const token = localStorage.getItem('gatekeeper_token'); // เพิ่ม token ถ้าจำเป็น
    const response = await axios.get('https://api-passport.advanceagro.net/fpapi/shop?q=', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // ส่งคืนข้อมูล
  } catch (error) {
    throw new Error('ไม่สามารถโหลดข้อมูลได้'); // ส่ง error กลับไปให้ component
  }
};

export const ItemShopData = async () => {
  try {
    const token = localStorage.getItem('gatekeeper_token'); // เพิ่ม token ถ้าจำเป็น
    const response = await axios.get('https://api-passport.advanceagro.net/fpapi/shop?q=%23me', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // ส่งคืนข้อมูล
  } catch (error) {
    throw new Error('ไม่สามารถโหลดข้อมูลได้'); // ส่ง error กลับไปให้ component
  }
};

export const ContractData = async () => {
  try {
    const token = localStorage.getItem('gatekeeper_token'); // เพิ่ม token ถ้าจำเป็น
    const response = await axios.get('https://api-passport.advanceagro.net/fpapi/documents/blank', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data; // ส่งคืนข้อมูล
  } catch (error) {
    throw new Error('ไม่สามารถโหลดข้อมูลได้'); // ส่ง error กลับไปให้ component
  }
};

export const ItemAdminShopData = async (query = '') => {
  try {
    const token = localStorage.getItem('gatekeeper_token');
    const response = await axios.get(
      `https://api-passport.advanceagro.net/fpapi/shop?q=${query}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('ไม่สามารถโหลดข้อมูลได้');
  }
};

export const ReNewShopData = async (query) => {
  try {
    const token = localStorage.getItem('gatekeeper_token');
    const response = await axios.get(`https://api-passport.advanceagro.net/fpapi/shop?q=${query}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('ไม่สามารถค้นหาร้านค้าได้');
  }
};

export const updateShopDataById = async (data) => {
  const token = localStorage.getItem("gatekeeper_token");
  try {
    const response = await axios.patch(
      "https://api-passport.advanceagro.net/fpapi/shop",
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    console.log("✅ API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error("❌ Error updating shop:", error);
    throw error;
  }
};



// ฟังก์ชันสำหรับอัปโหลดเอกสาร
export const uploadDocument = async (file, docTypeId) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('docTypeId', docTypeId);

  try {
    const response = await axios.post(`${url}/fpapi/document`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data; // คืนค่า response ของ API
  } catch (error) {
    console.error('Error uploading document:', error);
    throw error;
  }
};

// ตัวอย่างฟังก์ชันเพิ่มเติม (ถ้ามี)
export const getDocuments = async () => {
  try {
    const response = await axios.get(`${url}/fpapi/document-list`);
    return response.data;
  } catch (error) {
    console.error('Error fetching documents:', error);
    throw error;
  }
};

export const downloadChat = async (shopid: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/fpapi/chat/${shopid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadPath = async (shopid: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/fpapi/progress/${shopid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const downloadPathRecost = async (shopid: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/fpapi/progress/${shopid}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const uploadChat = async (shopid: any, message: any) => {
  const input = { message: message };
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.post(`${url}/fpapi/chat/${shopid}`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};

export const updatePlanApprove = async (input: any) => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.patch(`${url}/fpapi/shop/approve`, input, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  const data = res.data;
  return data;
};


export const uploadImage = async (formData) => {
  const token = localStorage.getItem("gatekeeper_token"); // ✅ ดึง Token จาก LocalStorage

  const response = await axios.post(
    `${url}/fpapi/document`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${token}`, // ✅ ใส่ Token ให้ API
        "Content-Type": "multipart/form-data", // ✅ ต้องใช้ multipart/form-data
      },
    }
  );

  return response.data;
};

export const downloadAdminWs = async () => {
  const token = localStorage.getItem('gatekeeper_token');
  const res = await axios.get(`${url}/fpapi/isAdmin`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};


export const getDocument = async (id: any) => {
  const token = localStorage.getItem('token');
  const res = await axios.get(`${url}/fpapi/document/${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = res.data;
  return data;
};

export const fetchDocuments = async (shopId) => {
  if (!shopId) {
    console.error("⚠️ shopId is missing!");
    throw new Error("ไม่มี shopId ไม่สามารถโหลดเอกสารได้");
  }

  try {
    const response = await axios.get(`${url}/fpapi/document/${shopId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
    });

    // 🔍 ตรวจสอบ Response เต็มๆ ว่ามีข้อมูลหรือไม่
    console.log("📂 API Response (เต็มๆ):", response);

    if (!response || !response.data) {
      console.error("🚨 API ไม่ได้ส่งข้อมูล (response.data เป็น undefined)");
      return [];
    }

    return Array.isArray(response.data) ? response.data : [];
  } catch (error) {
    console.error("🚨 API Error:", error);
    throw new Error("โหลดเอกสารไม่สำเร็จ");
  }
};


export const updateDocumentStatus = async (shopId, typeid, status, reasonid) => {
  try {
    const payload = { shopId, typeid, status, reasonid };
    console.log("📌 [REQUEST] ส่งข้อมูลไป API (PATCH):", payload);

    const response = await axios.patch(`${url}/fpapi/document/approve`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });

    console.log("✅ [RESPONSE] API ส่งค่ากลับมา:", response.data);

    if (response.status === 200 && response.data.result === "SUCCESS") {
      return { success: true, message: `✅ อัปเดตสถานะเป็น ${status} สำเร็จ!` };
    } else {
      return { success: false, message: `⚠️ อัปเดตสถานะล้มเหลว: ${response.data.message || "เกิดข้อผิดพลาด"}` };
    }
  } catch (error) {
    return { success: false, message: "🚨 ไม่สามารถอัปเดตสถานะได้" };
  }
};


export const checkAdmin = async () => {
  try {
    const response = await axios.get(`${url}/fpapi/isAdmin`, { // ✅ ใช้ backticks
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` // ✅ ใช้ token
      }
    });

    console.log("✅ ตรวจสอบสิทธิ์แอดมิน:", response.data);
    return response.data; // { value: true } หรือ { value: false }
  } catch (error) {
    console.error("🚨 ตรวจสอบสิทธิ์แอดมินล้มเหลว:", error);
    return { value: false }; // ถ้า error ให้ถือว่าไม่ใช่ Admin
  }
};


export const updateShopStatus = async (shopId, status) => {
  try {
    const payload = { shopId, status };
    console.log("📌 ส่งข้อมูลไป API (PATCH):", payload);

    // ✅ ใช้ `axios.patch()` เพื่ออัปเดตสถานะ
    const response = await axios.patch(`${url}/fpapi/shop/approve`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}` // ✅ ใช้ Token
      }
    });

    console.log("✅ API Response:", response.data);

    if (response.status === 200 && response.data.result === "SUCCESS") {
      return { success: true, message: `✅ อัปเดตสถานะเป็น ${status} สำเร็จ!` };
    } else {
      return { success: false, message: `⚠️ อัปเดตสถานะล้มเหลว: ${response.data.message || "เกิดข้อผิดพลาด"}` };
    }
  } catch (error) {
    console.error("🚨 Error updating status:", error);
    return { success: false, message: "🚨 ไม่สามารถอัปเดตสถานะได้" };
  }
};

export const fetchEmployees = async () => {
  try {
    const token = localStorage.getItem('gatekeeper_token');
    const res = await axios.get(`https://api-passport.advanceagro.net/fpapi/cd`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("📥 API Response:", res.data); // ✅ ตรวจสอบข้อมูลที่ได้รับ

    if (!res.data || !Array.isArray(res.data)) {
      throw new Error("🚨 fetchEmployees ไม่คืนค่าที่เป็น array");
    }

    return res.data; // ✅ ส่งคืนข้อมูลเป็น array
  } catch (err) {
    console.error('❌ โหลดพนักงานล้มเหลว:', err);
    return []; // ✅ คืนค่าเป็น array ว่าง เพื่อป้องกัน Error
  }
};

export const deleteEmployee = async (id) => {
  try {
    const token = localStorage.getItem('gatekeeper_token'); // เพิ่ม token ถ้าจำเป็น
    const res = await axios.delete(`https://api-passport.advanceagro.net/fpapi/cd/delete/${id}`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
    } );
    return res.data; // ส่งคืนข้อมูล Dropdown
  } catch (err) {
    console.error('Error fetching dropdown data:', err);
    throw err; // ส่งข้อผิดพลาดกลับ
  }
};

export const searchEmployee = async (query) => {
  try {
    // const token = getToken();
    const token = localStorage.getItem('gatekeeper_token'); // เพิ่ม token ถ้าจำเป็น

    const res = await axios.get(`https://api-passport.advanceagro.net/fpapi/cd/search?q=${query}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    console.log("🔎 ค้นหาพนักงาน:", res.data);

    return Array.isArray(res.data) ? res.data : [];  // ✅ ป้องกันกรณี API ไม่ส่ง array กลับมา
  } catch (err) {
    console.error('❌ ค้นหาพนักงานล้มเหลว:', err);
    return [];
  }
};
export const addEmployee = async (employeeId) => {
  try {
    // const token = getToken();
    const token = localStorage.getItem('gatekeeper_token'); // เพิ่ม token ถ้าจำเป็น
    const res = await axios.post(`https://api-passport.advanceagro.net/fpapi/cd/add`, 
      { employeeId }, 
      { headers: { Authorization: `Bearer ${token}` } }
    );

    console.log("✅ เพิ่มพนักงานสำเร็จ:", res.data);

    return res.data;
  } catch (err) {
    console.error('❌ เพิ่มพนักงานล้มเหลว:', err);
    throw err;
  }
};

export const saveSignature = async (signature) => {
  try {
    // const token = getToken();
    const token = localStorage.getItem('gatekeeper_token'); // เพิ่ม token ถ้าจำเป็น
    const res = await axios.patch(`https://api-passport.advanceagro.net/fpapi/cd/signature`, 
      { signature }, 
      { headers: { Authorization: `Bearer ${token}` } }
    );

    console.log("✅ บันทึกลายเซ็นสำเร็จ:", res.data);

    return res.data;
  } catch (err) {
    console.error('❌ กิดข้อผิดพลาดในการเชื่อมต่อ API:', err);
    throw err;
  }
};